<div class="flex flex-col justify-start items-stretch w-full bg-white border border-slate-200 py-8 px-4">
  <div class="flex flex-col space-y-6 md:w-2/3 w-full justify-start items-stretch self-center" *ngIf="currentUser">
    <h2 class="text-2xl">Comments</h2>
    <div
      class="flex md:flex-row flex-col md:gap-x-16 gap-x-0 gap-y-4 md:gap-y-0 justify-start items-stretch md:items-center py-6 w-full">
      <div class="flex-grow-0 justify-center items-center md:flex flex-col hidden flex-shrink">
        <button mat-fab disabled="true">
          {{ currentUser.id | userIdToName: true | async }}
        </button>
        <p class="strong">{{ currentUser?.name }}</p>
      </div>
      <mat-form-field class="flex-grow basis-full">
        <textarea matInput placeholder="Comment" [(ngModel)]="newComment.comment" class="form-control"></textarea>
      </mat-form-field>
      <button mat-raised-button [disabled]="!newComment?.comment || newComment.comment.length === 0" color="primary"
        (click)="add()">
        Add
      </button>
    </div>
    <hr />
    <div *ngFor="let comment of comments" class="flex flex-row mt-4 md:gap-x-16 gap-x-0">
      <div class="flex-grow-0 justify-center items-center md:flex flex-col hidden">
        <button mat-fab disabled="true">
          {{ comment.user_id | userIdToName: true | async }}
        </button>
        <p class="strong">{{ comment.user_id | userIdToName | async }}</p>
      </div>
      <div class="flex-grow flex flex-col justify-start items-stretch">
        <h3 class="md:hidden">{{ comment.user_id | userIdToName | async }}</h3>
        <blockquote>
          <p class="mb-3">{{ comment.comment }}</p>
          <footer>
            <cite>
              <p>
                {{ comment.created_at | amDateFormat: dateTimeFormat }}
              </p>
            </cite>
          </footer>
        </blockquote>
      </div>
      <hr />
    </div>
  </div>
</div>